import { render, staticRenderFns } from "./DateText.vue?vue&type=template&id=33d0ad8e&"
import script from "./DateText.vue?vue&type=script&lang=ts&"
export * from "./DateText.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports